import React, { FC, useMemo, useState } from 'react'
import { FaArrowUp, FaChevronRight } from 'react-icons/fa'
import cl from 'classnames'

import { Menu } from '@services/api/menus'

import Link from 'next/link'
import styles from './mobile.module.scss'
import { MenuContentFaleConosco } from '../menu-content/menu-content-fale-conosco'

export const MenuMobile: FC<Menu> = ({
  id,
  url,
  newTab,
  description,
  rel,
  target,
  menus
}) => {
  const [isOpenChildren, setIsOpenChildren] = useState(false)

  const hasChildren = useMemo(() => !!menus && menus.length > 0, [menus])
  const hasSubMenus = useMemo(() => {
    if (!hasChildren) return false
    return menus.some(menu => !!menu.menus && menu.menus.length > 0)
  }, [menus])

  if (id === 0) {
    return (
      <div>
        <div
          onClick={() => setIsOpenChildren(prev => !prev)}
          className={cl(styles.menuTitleContainer, {
            [styles.menuContainerOpened]: isOpenChildren
          })}
        >
          <span
            className={cl(styles.menuTitle, {
              [styles.menuTitleOpened]: isOpenChildren
            })}
          >
            {description}
          </span>

          <FaChevronRight
            className={`${styles.icons} ${
              isOpenChildren ? '-rotate-90' : 'rotate-90'
            }`}
          />
        </div>

        {isOpenChildren && <MenuContentFaleConosco />}
      </div>
    )
  }

  return (
    <div>
      {url ? (
        <Link
          href={url}
          rel={rel || 'follow'}
          target={target || '_self'}
          className={cl(styles.menuTitleContainer, {
            [styles.menuContainerOpened]: isOpenChildren
          })}
          {...(newTab && { target: '_blank', rel: 'noreferrer' })}
        >
          <span
            className={cl(styles.menuTitle, {
              [styles.menuTitleOpened]: isOpenChildren
            })}
          >
            {description}
          </span>

          <FaArrowUp className={`${styles.icons} rotate-45`} />
        </Link>
      ) : (
        <div
          onClick={() => setIsOpenChildren(prev => !prev)}
          className={cl(styles.menuTitleContainer, {
            [styles.menuContainerOpened]: isOpenChildren
          })}
        >
          <span
            className={cl(styles.menuTitle, {
              [styles.menuTitleOpened]: isOpenChildren
            })}
          >
            {description}
          </span>

          <FaChevronRight
            className={`${styles.icons} ${
              isOpenChildren ? '-rotate-90' : 'rotate-90'
            }`}
          />
        </div>
      )}

      {hasChildren && (
        <div
          className={`flex flex-col overflow-auto ${
            isOpenChildren ? 'max-h-[240px] mt-4 mb-2' : 'max-h-0 my-0'
          } ${
            hasSubMenus
              ? 'gap-4 md:flex-row md:flex-wrap md:gap-x-8'
              : 'md:gap-1'
          } transition-all duration-500`}
        >
          {menus?.map(menu => {
            const hasSubMenu = menu.menus && menu.menus.length > 0

            return hasSubMenu ? (
              <div key={`menu-${menu.id}`} className="flex flex-col">
                {menu.url ? (
                  <Link
                    href={menu.url}
                    className={styles.subItem}
                    {...(menu.newTab && {
                      target: '_blank',
                      rel: 'noreferrer'
                    })}
                  >
                    {menu.description}
                  </Link>
                ) : (
                  <span className={styles.subItem}>{menu.description}</span>
                )}

                <div className="flex flex-col md:gap-1">
                  {menu.menus.map(menuChildren =>
                    menuChildren.url ? (
                      <Link
                        key={`menu-children-sub-item-${menuChildren.id}`}
                        href={menuChildren.url}
                        className={styles.subItemChildren}
                        {...(menuChildren.newTab && {
                          target: '_blank',
                          rel: 'noreferrer'
                        })}
                      >
                        {menuChildren.description}
                      </Link>
                    ) : (
                      <span
                        key={`menu-children-sub-item-${menuChildren.id}`}
                        className={styles.subItemChildren}
                      >
                        {menuChildren.description}
                      </span>
                    )
                  )}
                </div>
              </div>
            ) : (
              <div key={`menu-${menu.id}`} className="flex flex-col md:gap-1">
                {menu.url ? (
                  <Link
                    href={menu.url}
                    className={styles.subItemChildren}
                    {...(menu.newTab && {
                      target: '_blank',
                      rel: 'noreferrer'
                    })}
                  >
                    {menu.description}
                  </Link>
                ) : (
                  <span className={styles.subItemChildren}>
                    {menu.description}
                  </span>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
